import { ExamEventResultSection } from '@exam-center/exam-event-results';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionGuard } from '@shared/permissions';

export default function ExamEventResultsPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW}>
      <ExamEventResultSection />
    </PermissionGuard>
  );
}
